<template>
  <div>
    <v-overlay :value="overlay" absolute style="z-index: 9999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-leaf-circle</v-icon>
          CERTIFICADOS FITOSANITARIOS
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-btn class="mx-4" small color="primary" @click="abrirDialogCfsDeGuia()">
          <v-icon left>mdi-plus-circle-outline</v-icon> Nuevo Cfe
        </v-btn>

        <v-btn class="mx-4" small color="blue" dark @click="descargarXmlMultiples()"><v-icon left>mdi-xml</v-icon> Generar
          XML</v-btn>

      </v-toolbar>
      <v-toolbar flat color="white" class="mt-2">
        <v-col cols="2">
          <v-text-field clearable v-model="busConsignatario" label="Consignatario" append-icon="mdi-magnify"
            @click:append="cargarLista()" @keyup.enter="cargarLista()"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field clearable v-model="busAwb" label="Guia" append-icon="mdi-magnify" @click:append="cargarLista()"
            @keyup.enter="cargarLista()"></v-text-field>
        </v-col>

        <v-col cols="2">
          <v-text-field clearable append-icon="mdi-magnify" v-model="busFechaDesde" label="Fecha desde" type="date" @click:append="cargarLista()" @keyup.enter="cargarLista()"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field clearable append-icon="mdi-magnify" v-model="busFechaHasta" label="Fecha hasta" type="date" @click:append="cargarLista()" @keyup.enter="cargarLista()"></v-text-field>
        </v-col>
      </v-toolbar>
      <v-data-table :headers="headers" :items="lista" :items-per-page="itemsPerPage" :search="search"
        :loading="loadingTable" class="elevation-1" v-model="selected" show-select item-key="CFS_ID">
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="green" @click="abrirDialogCfs(item.CFS_ID)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>


        </template>
        <template v-slot:item.COD_USO_PREVISTO="{ item }">
          {{ nombreUsoPrevisto(item.COD_USO_PREVISTO) }}
        </template>


      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogCfs" persistent full-width scrollable>
      <v-card>
        <v-toolbar flat color="blue" dark height="40">
          <v-icon left>mdi-leaf-circle</v-icon>
          <span class="headline">Certificado Fitosanitario</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCfs = !dialogCfs">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4 pb-2">
          <v-form ref="formCfs">
            <v-row>
              <v-col class="pt-2 pb-2" cols="2">
                <v-btn color="blue" title="Exportar XML" @click="descargarXml()" small dark><v-icon left
                    small>mdi-xml</v-icon>Descargar XML</v-btn>
              </v-col>
              
              <v-col cols="2" class="ml-6">
                
                <v-form ref="formEstadoCert"> 
                  <v-text-field v-if="datosCfs.CFS_ESTADO=='PENDIENTE'" :rules="requiredRule" class="pt-0 mt-0" v-model="datosCfs.NUM_CERTIFICADO" label="Numero certificado" ></v-text-field>                 
                </v-form>
              </v-col>
              <v-col cols="2">
                <v-btn v-if="datosCfs.CFS_ESTADO=='PENDIENTE'" color="green" title="Cambiar estado" @click="cambiarEstado('REVISION')" small dark ><v-icon left
                    small>mdi-content-save</v-icon>En Revisión</v-btn>
                  
                  <v-btn v-if="datosCfs.CFS_ESTADO=='REVISION'" color="green" title="Cambiar estado" @click="cambiarEstado('APROBADO')" small dark ><v-icon left
                    small>mdi-check</v-icon>Aprobado</v-btn>
                </v-col>

                
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-0" cols="12">
                <v-tabs>
                  <v-tab>Datos generales</v-tab>
                  <v-tab>Puertos destino</v-tab>
                  <v-tab>Productos</v-tab>
                  <v-tab>Adjuntos</v-tab>

                  <v-tab-item>
                    
                    <v-row>
                      <v-col class="pt-4 pb-0" cols="6">
                        <v-text-field :rules="requiredRule" type="date" v-model="datosCfs.FECHA_EMBARQUE"
                          label="fecha embarque"></v-text-field>
                      </v-col>
                      <v-col class="pt-4 pb-0" cols="6">
                        <v-text-field :rules="requiredRule" v-model="datosCfs.TIPO_SOLICITUD" label="Tipo de solicitud"
                          @change="ajustarUsoPrevisto()"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-select :rules="requiredRule" v-model="datosCfs.COD_IDIOMA" :items="idiomas" item-text="NOMBRE"
                          item-value="COD_IDIOMA" label="Idioma"></v-select>
                      </v-col>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-select :rules="requiredRule" v-model="datosCfs.COD_TIPO_PRODUCCION" :items="tiposProduccion" item-text="NOMBRE"
                          item-value="COD_TIPO_PRODUCCION" label="Tipo de producción"></v-select>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-text-field :rules="requiredRule" v-model="datosCfs.NOMBRE_CONSIGNATARIO"
                          label="Nombre del consignatario"></v-text-field>
                      </v-col>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-text-field :rules="requiredRule" v-model="datosCfs.AWB" label="AWB"></v-text-field>
                      </v-col>


                    </v-row>
                    <v-row>
                      <v-col class="pt-0 pb-0" cols="12"><v-text-field :rules="requiredRule" v-model="datosCfs.DIRECCION_CONSIGNATARIO"
                          label="Dirección consignatario">
                        </v-text-field></v-col>
                    </v-row>


                    <v-row>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-text-field :rules="requiredRule" v-model="datosCfs.MARCAS" label="Marcas"></v-text-field>
                      </v-col>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-text-field  v-model="datosCfs.INFORMACION_ADICIONAL"
                          label="Información adicional"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-select :rules="requiredRule" v-model="datosCfs.COD_USO_PREVISTO" :items="usosPrevistos" item-text="NOMBRE"
                          item-value="COD_USO_PREVISTO" label="Uso previsto"></v-select>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-autocomplete v-model="datosCfs.COD_PUERTO_EC" :items="puertos" item-text="NOMBRE"
                          item-value="COD_PUERTO_EC" label="Puerto Ecuador"></v-autocomplete>
                      </v-col>
                      <v-col class="pt-0 pb-0" cols="6">
                        <v-select v-model="datosCfs.FORMA_PAGO" :items="formasPago" item-text="NOMBRE"
                          item-value="COD_FORMA_PAGO" label="Forma de pago"></v-select>
                      </v-col>

                    </v-row>
                  
                    <v-row class="mb-2">
                      <v-col class="text-center">
                        <v-btn small color="primary" @click="guardarCfs()">
                          <v-icon>mdi-content-save</v-icon> Guardar
                        </v-btn>
                        &nbsp;&nbsp;
                        <v-btn small @click="dialogCfs = !dialogCfs">
                          <v-icon>mdi-cancel</v-icon> Cancelar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-toolbar flat color="white">
                      <v-spacer></v-spacer>
                      <v-btn small color="primary" @click="abrirDialogPuerto(null)">
                        <v-icon>mdi-plus-circle-outline</v-icon> Agregar puerto destino
                      </v-btn>
                    </v-toolbar>
                    <v-row>
                      <v-col>
                        <v-data-table :headers="certPdestinoHeaders" :items="certPdestino" class="elevation-1"
                          :loading="loadingTable" :items-per-page="itemsPerPage">

                          <template v-slot:item.acciones="{ item }">
                            <v-btn icon label="Eliminar puerto" color="red" @click="eliminarPuertoCfs(item.ID)">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>

                            <v-btn icon label="Modificar puerto" color="green" @click="abrirDialogPuerto(item)">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>

                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col class="mt-6 ">

                        <v-toolbar flat color="white">
                          <v-col cols="2">
                            <v-text-field class="ma-0 pa-0 " outlined v-model="totalBultos"
                              label="Total bultos"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field outlined v-model="totalTallos" label="Total tallos"></v-text-field>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-btn small color="primary" @click="abrirDialogProductoCfs(null)">
                            <v-icon>mdi-plus-circle-outline</v-icon> Agregar producto exportador
                          </v-btn>

                        </v-toolbar>
                        <v-data-table :headers="certProductosHeaders" :items="certProductos" class="elevation-1"
                          :loading="loadingTable" :items-per-page="itemsPerPage">


                          <template v-slot:item.acciones="{ item }">
                            <v-btn icon label="Eliminar producto" color="red" @click="eliminarProductoCfs(item.ID)">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>

                            <v-btn icon label="Modificar producto" color="green" @click="abrirDialogProductoCfs(item)">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>

                      </v-col>

                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-form ref="formAdjuntos">
                      <v-file-input multiple id="archivosAdjuntos" label="adjuntar" v-model="archivoSelecionados"
                        @change="cargarArchivos"></v-file-input>
                    </v-form>
                    <!-- <v-toolbar flat color="white">                              
                              <v-spacer></v-spacer>
                              <v-btn small color="primary" @click="abrirDialogCfs(null)">
                                <v-icon>mdi-attachment</v-icon> Agregar adjunto
                              </v-btn>
                              </v-toolbar> -->
                    <v-row>
                      <v-col>
                        <v-data-table :headers="certadjuntosHeaders" :items="certAdjuntos" class="elevation-1"
                          :loading="loadingTable" :items-per-page="itemsPerPage">
                          <template v-slot:item.acciones="{ item }">
                            <v-btn icon label="Eliminar adjunto" color="red" @click="eliminarAdjuntoCfs(item.ID)">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>

                            <v-btn icon label="Descargar adjunto" color="green" @click="descargarAdjunto(item.URL, item.NOMBRE_ARCHIVO)">
                              <v-icon small>mdi-download</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>


                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

      </v-card>
    </v-dialog>

    <!-- dialogo puerto -->
    <v-dialog v-model="dialogPuerto" persistent width="500" scrollable>
      <v-card>
        <v-toolbar flat color="blue" dark height="40">
          <v-icon left>mdi-map-marker</v-icon>
          <span class="headline">Puerto Destino</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogPuerto = !dialogPuerto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4 pb-2">
          <v-form ref="formPuerto">
            <v-row>
              <v-col cols="12">
                
                <v-autocomplete :rules="requiredRule" v-model="datosPuerto.CODIGO_PUERTO" :items="puertosDestino" item-text="AP_NOMBRE"
                  item-value="CODIGO_PUERTO" label="Puerto">
                  <template v-slot:item="{ item }">
                    <v-list-item-title>{{ item.AP_NOMBRE }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.CODIGO_PUERTO }}</v-list-item-subtitle>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="datosPuerto.CODIGO_PUERTO" label="Código del puerto"></v-text-field>
              </v-col>

            </v-row>

            <v-row class="text-center">
              <v-col cols="12">
                <v-btn small color="primary" @click="guardarPuertoCfs()">
                  <v-icon small left>mdi-content-save</v-icon>Guardar
                </v-btn>
                &nbsp;&nbsp;
                <v-btn small @click="dialogPuerto = !dialogPuerto"><v-icon small
                    left>mdi-cancel</v-icon>Cancelar</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialogo producto -->
    <v-dialog v-model="dialogProducto" persistent width="500" scrollable>
      <v-card>
        <v-toolbar flat color="blue" dark height="40">
          <v-icon left>mdi-leaf</v-icon>
          <span class="headline">Producto Exportador</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogProducto = !dialogProducto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4 pb-2">
          <v-form ref="formProducto">
            <v-row>
              <v-col cols="12">
                <v-autocomplete :rules="requiredRule" v-model="datosProducto.CODIGO_PRODUCTO" :items="productosAc"
                  item-value="ID_PRODUCTO_UNICO" item-text="NOMBRE_COMUN" label="Código del producto">
                  <template v-slot:item="{ item }">
                    <v-list-item-title>{{ item.NOMBRE_COMUN }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.ID_PRODUCTO_UNICO }}</v-list-item-subtitle>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="py-0 my-0">
                <v-autocomplete :rules="requiredRule" v-model="datosProducto.IDENT_EXPORTADOR" :items="fincas" item-value="ENTE_RUC"
                  item-text="FINCA_NOMBRE" label="Exportador"></v-autocomplete>
              </v-col>

              <v-col cols="6" class="py-0 my-0">
                <v-text-field :rules="requiredRule" v-model="datosProducto.CANTIDAD" label="Cantidad"></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0 my-0">
                <v-text-field :rules="requiredRule" v-model="datosProducto.BULTOS" label="Bultos"></v-text-field>
              </v-col>


            </v-row>

            <v-row class="text-center">
              <v-col cols="12" class="mb-2">
                <v-btn small color="primary" @click="guardarProductoCfs()">
                  <v-icon small left>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
                &nbsp;&nbsp;
                <v-btn small @click="dialogProducto = !dialogProducto"><v-icon small
                    left>mdi-cancel</v-icon>Cancelar</v-btn>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCfsDeGuia" width="600">
      <v-card>
        <v-toolbar flat color="blue" dark height="40">
          <v-icon left>mdi-leaf-circle</v-icon>
          <span class="headline">Crear Certificado Fitosanitario</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCfsDeGuia = !dialogCfsDeGuia">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4 pb-2">
          
          <p>Crear un nuevo certificado a partir de los datos de una guía </p>
          <v-row class="mt-2 pt-0 pb-0 mb-0">
            <v-col cols="12" class="py-0 my-0">
              <v-text-field v-model="numGuia" label="Número de guía"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0 pt-0">
            <v-col cols="12" class="py-0 my-0">
              <v-checkbox v-model="crearUnCfsPorExportador" label="Crear un Certificado por exportador"></v-checkbox>
            </v-col>
          </v-row>

          <v-row class="text-center mb-1">
            <v-col cols="12">
              <v-btn class="mx-4" small color="primary" @click="crearCfsDeGuia()"><v-icon left small>mdi-cogs</v-icon>Crear
                CFE</v-btn>
              
              <v-btn class="mx-4" small @click="dialogCfsDeGuia = !dialogCfsDeGuia"><v-icon left>mdi-cancel</v-icon>Cancelar</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import axios from "axios";

export default {
  name: "CertificadoFse",
  data: () => ({
    overlay: false,
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "CFS_ID" },
      { text: "Fecha", value: "FECHA_EMBARQUE" },
      { text: "Consignatario", value: "NOMBRE_CONSIGNATARIO" },
      { text: "AWB", value: "AWB" },
      { text: "Tipo solicitud", value: "TIPO_SOLICITUD" },
      { text: "Uso previsto", value: "COD_USO_PREVISTO" },
      { text: "Estado", value: "CFS_ESTADO" },
      { text: "Numero certificado", value: "NUM_CERTIFICADO" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        String(v)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Ingrese un Email válido",
    ],

    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,
    search: null,
    incluirInactivos: false,
    dialogCfs: false,
    datosCfs: {},
    tiposSolicitud: [],
    tiposProduccion: [],
    idiomas: [],
    itemsPerPage: 20,
    creaCfs: true,
    archivoSelecionados: [],
    certProductosHeaders: [
      { text: "Acciones", value: "acciones", sortable: false },
      { text: "Código", value: "CODIGO_PRODUCTO" },
      { text: "Producto", value: "NOMBRE_PRODUCTO" },
      { text: "Cantidad", value: "CANTIDAD" },
      { text: "Bultos", value: "BULTOS" },
      { text: "Exportador", value: "IDENT_EXPORTADOR" },
      { text: "Nombre exportador", value: "NOMBRE_EXPORTADOR" },
    ],
    certProductos: [],
    certadjuntosHeaders: [
      { text: "Acciones", value: "acciones", sortable: false },
      { text: "Nombre", value: "NOMBRE_ARCHIVO" },
      { text: "Url", value: "URL" },
      { text: "ID", value: "ID" },
    ],
    certAdjuntos: [],
    certPdestinoHeaders: [
      { text: "Acciones", value: "acciones", sortable: false },
      { text: "Codigo del puerto", value: "COD_PUERTO" },
      { text: "Nombre  del puerto", value: "NOMBRE_PUERTO" },
      { text: "Pais", value: "NOMBRE_PAIS" },
      { text: "ID", value: "ID" },
    ],
    certPdestino: [],
    puertos: [{ NOMBRE: "AEROPUERTO INTERNACIONAL JOSE JOAQUIN DE OLMEDO", COD_PUERTO_EC: "AEECGYE" },
    { NOMBRE: "AMBATO", COD_PUERTO_EC: "PTECATF" },
    { NOMBRE: "AMBATO-CHACHOAN AIRPORT", COD_PUERTO_EC: "AEECATF" },
    { NOMBRE: "BAHIA DE CARAQUEZ", COD_PUERTO_EC: "PTECBHA" },
    { NOMBRE: "BAHIA DE CARAQUEZ-BAHIA DE CARAQUEZ AIRPORT", COD_PUERTO_EC: "AEECBHA" },
    { NOMBRE: "BALAO", COD_PUERTO_EC: "PTECEBL" },
    { NOMBRE: "CALETA TAGUS", COD_PUERTO_EC: "PTECCAT" },
    { NOMBRE: "CHANDUY", COD_PUERTO_EC: "PTECCHA" },
    { NOMBRE: "COCA-COCA AIRPORT", COD_PUERTO_EC: "AEECOCC" },
    { NOMBRE: "CUENCA", COD_PUERTO_EC: "AEECCUE" },
    { NOMBRE: "CUENCA-CUENCA AIRPORT", COD_PUERTO_EC: "AEECCUE" },
    { NOMBRE: "DURAN", COD_PUERTO_EC: "PTECDUN" },
    { NOMBRE: "EL CARMEN", COD_PUERTO_EC: "PTECELC" },
    { NOMBRE: "ESMERALDAS", COD_PUERTO_EC: "MAECESM" },
    { NOMBRE: "ESMERALDAS-ESMERALDAS AIRPORT", COD_PUERTO_EC: "AEECESM" },
    { NOMBRE: "GALAPAGOS ISLANDS", COD_PUERTO_EC: "PTECGPS" },
    { NOMBRE: "GALAPAGOS ISLANDS-BALTRA AIRPORT", COD_PUERTO_EC: "AEECGPS" },
    { NOMBRE: "GUAYAQUIL", COD_PUERTO_EC: "MAECGYE" },
    { NOMBRE: "HUAQUILLAS", COD_PUERTO_EC: "TEECZZB" },
    { NOMBRE: "IBARRA", COD_PUERTO_EC: "PTECZZH" },
    { NOMBRE: "ISLE BALTA-OFF-LINE POINT", COD_PUERTO_EC: "AEECWGL" },
    { NOMBRE: "ITAYA, ECUADOR", COD_PUERTO_EC: "PTECITY" },
    { NOMBRE: "JIPIJAPA-JIPIJAPA AIRPORT", COD_PUERTO_EC: "AEECJIP" },
    { NOMBRE: "LA LIBERTAD", COD_PUERTO_EC: "PTECLLD" },
    { NOMBRE: "LAGO AGRIO-LAGO AGRIO AIRPORT", COD_PUERTO_EC: "AEECLGQ" },
    { NOMBRE: "LATACUNGA", COD_PUERTO_EC: "PTECZZG" },
    { NOMBRE: "LATACUNGA-COTAPAXI INTERNATIONAL AIRPORT", COD_PUERTO_EC: "AEECLTX" },
    { NOMBRE: "LOJA", COD_PUERTO_EC: "PTECLOH" },
    { NOMBRE: "LOJA-LOJA AIRPORT", COD_PUERTO_EC: "AEECLOH" },
    { NOMBRE: "MACARA", COD_PUERTO_EC: "TEECMRR" },
    { NOMBRE: "MACARA-MACARA AIRPORT", COD_PUERTO_EC: "AEECMRR" },
    { NOMBRE: "MACAS", COD_PUERTO_EC: "PTECZZA" },
    { NOMBRE: "MACAS-MACAS AIRPORT", COD_PUERTO_EC: "AEECXMS" },
    { NOMBRE: "MACHALA", COD_PUERTO_EC: "PTECMCH" },
    { NOMBRE: "MACHALA-MACHALA AIRPORT", COD_PUERTO_EC: "AEECMCH" },
    { NOMBRE: "MANTA", COD_PUERTO_EC: "MAECMEC" },
    { NOMBRE: "MANTA-MANTA AIRPORT", COD_PUERTO_EC: "AEECMEC" },
    { NOMBRE: "MENDEZ-MENDEZ AIRPORT", COD_PUERTO_EC: "AEECMZD" },
    { NOMBRE: "MONTEVERDE", COD_PUERTO_EC: "PTECMTV" },
    { NOMBRE: "NUEVA LOJA - CEBAF SAN MIGUEL ( LAGO AGRIO - CEBAF)", COD_PUERTO_EC: "TEECZZM" },
    { NOMBRE: "NUEVO ROCAFUERTE", COD_PUERTO_EC: "PTECZZL" },
    { NOMBRE: "POMPEYA - RIO COCA", COD_PUERTO_EC: "PTECZZD" },
    { NOMBRE: "PORTOVIEJO", COD_PUERTO_EC: "PTECPVO" },
    { NOMBRE: "POSORJA", COD_PUERTO_EC: "PTECZZF" },
    { NOMBRE: "POSORJA", COD_PUERTO_EC: "PTECPSG" },
    { NOMBRE: "POSORJA", COD_PUERTO_EC: "MAECPSJ" },
    { NOMBRE: "PUERTO AYORA, ISLA SANTA CRUZ", COD_PUERTO_EC: "PTECAYO" },
    { NOMBRE: "PUERTO BAQUERIZO MORENO, SNC", COD_PUERTO_EC: "PTECBAQ" },
    { NOMBRE: "PUERTO BOLIVAR", COD_PUERTO_EC: "MAECPBO" },
    { NOMBRE: "PUERTO BOLIVAR (no utilizado)", COD_PUERTO_EC: "PTECPBV" },
    { NOMBRE: "PUERTO MORONA", COD_PUERTO_EC: "PTECSPM" },
    { NOMBRE: "PUERTO VILLAMIL, ISLA ISABELA", COD_PUERTO_EC: "PTECVIL" },
    { NOMBRE: "PUNA", COD_PUERTO_EC: "PTECPUN" },
    { NOMBRE: "PUNTA ARENAS", COD_PUERTO_EC: "PTECZZC" },
    { NOMBRE: "QUEVEDO", COD_PUERTO_EC: "PTECZZJ" },
    { NOMBRE: "QUITO", COD_PUERTO_EC: "PTECUIO" },
    { NOMBRE: "QUITO-MARISCAL SUCRE AIRPORT", COD_PUERTO_EC: "AEECUIO" },
    { NOMBRE: "RIOBAMBA", COD_PUERTO_EC: "PTECRBA" },
    { NOMBRE: "SALINAS", COD_PUERTO_EC: "PTECSNC" },
    { NOMBRE: "SALINAS-SALINAS AIRPORT", COD_PUERTO_EC: "AEECSNC" },
    { NOMBRE: "SAN CRISTOBAL-SAN CRISTOBAL AIRPORT", COD_PUERTO_EC: "AEECSCY" },
    { NOMBRE: "SAN LORENZO", COD_PUERTO_EC: "PTECSLR" },
    { NOMBRE: "SANTA ROSA", COD_PUERTO_EC: "PTECETR" },
    { NOMBRE: "SANTO DOMINGO DE LOS COLORADOS", COD_PUERTO_EC: "PTECSDO" },
    { NOMBRE: "SUCUA-SUCUA AIRPORT", COD_PUERTO_EC: "AEECSUQ" },
    { NOMBRE: "TAISHA-TAISHA AIRPORT", COD_PUERTO_EC: "AEECTSC" },
    { NOMBRE: "TARAPOA-TARAPOA AIRPORT", COD_PUERTO_EC: "AEECTPC" },
    { NOMBRE: "TEPRE", COD_PUERTO_EC: "PTECTEP" },
    { NOMBRE: "TIPUTINI-TIPUTINI AIRPORT", COD_PUERTO_EC: "AEECTPN" },
    { NOMBRE: "TULCAN", COD_PUERTO_EC: "TEECZZE" },
    { NOMBRE: "TULCAN-TULCAN AIRPORT", COD_PUERTO_EC: "AEECTUA" },
    { NOMBRE: "YRALPA", COD_PUERTO_EC: "PTECZZK" },
    { NOMBRE: "ZONA FRANCA MANABI", COD_PUERTO_EC: "PTECZZI" }],
    productos: [],
    idiomas: [
      { COD_IDIOMA: "SPA", NOMBRE: "Español" },
      { COD_IDIOMA: "ENG", NOMBRE: "Inglés" },
      { COD_IDIOMA: "PTG", NOMBRE: "Portugués" },
      { COD_IDIOMA: "RUS", NOMBRE: "Ruso" },
    ],
    formasPago: [
      { COD_FORMA_PAGO: "SALDO", NOMBRE: "Saldo" },
      { COD_FORMA_PAGO: "ELECTRONICO", NOMBRE: "Electrónico" },
    ],
    tiposProduccion: [
      { COD_TIPO_PRODUCCION: "ORG", NOMBRE: "Orgánico" },
      { COD_TIPO_PRODUCCION: "CONV", NOMBRE: "Convencional" },
    ],
    usosPrevistos: [
      { COD_USO_PREVISTO: "0001", NOMBRE: "Plantación" },
      { COD_USO_PREVISTO: "0002", NOMBRE: "Consumo" },
      { COD_USO_PREVISTO: "0003", NOMBRE: "Procesamiento" },
      { COD_USO_PREVISTO: "0004", NOMBRE: "Decoración" },
      { COD_USO_PREVISTO: "0005", NOMBRE: "Germinación para consumo" },
      { COD_USO_PREVISTO: "0006", NOMBRE: "Investigación" },
    ],
    dialogPuerto: false,
    datosPuerto: {
      ID: "",
      CFS_ID: "",
      CODIGO_PUERTO: "",
      TIPO: ""
    },
    dialogProducto: false,
    datosProducto: {
      ID: "",
      CODIGO_PRODUCTO: "",
      CANTIDAD: "",
      BULTOS: "",
      IDENT_EXPORTADOR: "",
    },
    dialogCfsDeGuia: false,
    numGuia: "",
    productosAc: [],
    fincas: [],
    puertosDestino: [],
    busConsignatario: "",
    busAwb: "",
    busFechaDesde: "",
    busFechaHasta: "",
    selected: [],
    crearUnCfsPorExportador: false,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user", "token", "url"]),
    ...mapGetters("access", [""]),

    totalBultos() {
      let total = 0;
      for (let i = 0; i < this.certProductos.length; i++) {
        total += parseFloat(this.certProductos[i].BULTOS);
      }
      return total;
    },

    totalTallos() {
      let total = 0;
      for (let i = 0; i < this.certProductos.length; i++) {
        total += parseFloat(this.certProductos[i].CANTIDAD);
      }
      return total;
    }

  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    validarEmail(email) {
      if (email == "") {
        return [true];
      }
      if (email == null) {
        return [true];
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return ["Email inválido"];
      } else {
        return [true];
      }
    },



    cargarLista() {
      this.overlay = true;
      this.setLoadingTable(true);
      this.setUrl("api/cfs-lista-certificados");
      this.requestApi({
        method: "GET",
        data: {          
          consignatario: this.busConsignatario,
          awb: this.busAwb,
          fechaDesde: this.busFechaDesde,
          fechaHasta: this.busFechaHasta,
        },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data;
          this.pageCount = 10;
        })
        .catch((res) => {
          this.setLoadingTable(false);
          this.overlay = false
        })
        .finally(() => {
          this.setLoadingTable(false);
          this.overlay = false
        });
    },

    modificarCfs() {
      this.setUrl("api/cfs-modificar-certificado");
      this.requestApi({
        method: "POST",
        data: {
          cfs_id: this.datosCfs.CFS_ID,
          datos: this.datosCfs,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
          this.dialogCfs = false;
        })
        .catch((res) => {
          this.alertNotification({ param: { html: res.detail } });
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });
    },

    abrirDialogCfs(cfsid) {
      this.creaCfs = false;
      if (cfsid == null) {
        this.datosCfs = {
          CFS_ID: "",
          NOMBRE_CONSIGNATARIO: "",
          DIRECCION_CONSIGNATARIO: "",
          CFS_ESTADO: "",
          FECHA_EMBARQUE: "",
          COD_IDIOMA: "",
          COD_TIPO_PRODUCCION: "",
          COD_PUERTO_EC: "",
          TIPO_SOLICITUD: "",
          AWB: "",
          MARCAS: "",
          INFORMACION_ADICIONAL: "",
          COD_USO_PREVISTO: "0004",
          FORMA_PAGO: "",
          NUM_CERTIFICADO: "",
        };
        this.creaCfs = true;
      }
      this.cargarDatosCertificado(cfsid);

    },

    cargarDatosCertificado(cfsid) {
      this.overlay = true;
      this.setUrl("api/cfs-datos-certificado");
      this.requestApi({
        method: "GET",
        data: {
          cfs_id: cfsid,
        },
      })
        .then((res) => {
          if (res.data.certificado != null) {
            this.datosCfs = res.data.certificado;
          }
          this.certProductos = res.data.productos || [];
          this.certAdjuntos = res.data.adjuntos || [];
          this.certPdestino = res.data.puertos_destino || [];
          this.productos = res.data.productos || [];
          this.productosAc = res.data.productos_ac;
          this.fincas = res.data.fincas;
          this.puertosDestino = res.data.aeropuertos;
          this.dialogCfs = true;
        })
        .catch((res) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;

        });
    },

    eliminarProductoCfs(id) {
      Vue.swal({
        html: "Está seguro de eliminar el item ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.overlay = true;
          this.setUrl("api/cfs-borrar-producto");
          this.requestApi({
            method: "POST",
            data: {
              id: id,
            },
          }).then((res) => {
            //console.log(res);
            this.overlay = false;
            this.cargarDatosCertificado(this.datosCfs.CFS_ID);
            this.alertNotification({ param: { html: res.data.msg } });
          }).catch((res) => {
            this.overlay = false;
            this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          }).finally(() => {
            this.overlay = false;
          });
        }
      });
    },

    eliminarAdjuntoCfs(adjuntoId) {
      Vue.swal({
        html: "Está seguro de eliminar el adjunto ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.overlay = true;
          this.setUrl("api/cfs-borrar-adjunto");
          this.requestApi({
            method: "POST",
            data: {
              id: adjuntoId,
            },
          }).then((res) => {
            //console.log(res);            
            this.cargarDatosCertificado(this.datosCfs.CFS_ID);
            this.alertNotification({ param: { html: res.data.msg } });
            this.overlay = false;
          }).catch(() => {
            this.overlay = false;
            this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          }).finally(() => {
            this.overlay = false;
          });
        }
      });
    },
    guardarCfs() {
      if (!this.$refs.formCfs.validate()) {
        return false;
      }
      if (this.creaCfs == true) {
        this.crearCfs();
      } else {
        this.modificarCfs();
      }
    },
    cargarArchivos() {
      let tamanoTotal = 0;
      for (let i = 0; i < this.archivoSelecionados.length; i++) {
        tamanoTotal += this.archivoSelecionados[i].size;
      }

      if (this.archivoSelecionados.length > 10 && tamanoTotal < 10000000) {
        alert("Va a cargar muchos archivos está seguro ? ");
        return false;
      }

      if (tamanoTotal >= 100000000) {
        alert("Va a cargar archivos por más de 100MB está seguro ? ");
        return false;
      }

      let formData = new FormData();

      for (let i = 0; i < this.archivoSelecionados.length; i++) {
        formData.append("archivos[]", this.archivoSelecionados[i]);
      }

      formData.append("user_name", this.user.user_login_id);
      formData.append("cfs_id", this.datosCfs.CFS_ID);

      //console.log(this.archivoSelecionados);

      this.overlay = true;
      this.setUrl("api/cfs-agregar-adjunto");
      //alert(this.token);

      axios
        .post(this.url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.overlay = false;

          this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          this.alertNotification({
            param: {
              html: res.data.msg,
            },
          });
        })
        .catch((err) => {
          this.overlay = false;
        })
        .finally((err) => {
          this.overlay = false;
        });
    },

    abrirDialogPuerto(item) {
      this.dialogPuerto = true;
      //this.overlay = true;
      if(item != null){
        console.log(item);
        this.datosPuerto = {
          ID: item.ID,
          CODIGO_PUERTO: item.COD_PUERTO,
          TIPO: item.TIPO
        };
      } else {
        this.datosPuerto = {
          ID: "",
          CODIGO_PUERTO: "",
          TIPO: ""
        };
      }
      this.overlay = false;

      
    },

    guardarPuertoCfs() {
      if (!this.$refs.formPuerto.validate()) {
        return false;
      }      
      this.overlay = true;
      if(this.datosPuerto.ID == ""){
      this.setUrl("api/cfs-agregar-pdest");
      this.requestApi({
        method: "POST",
        data: {
          cfs_id: this.datosCfs.CFS_ID,
          codigo_puerto: this.datosPuerto.CODIGO_PUERTO,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          this.dialogPuerto = false;
        })
        .catch((res) => {
          this.alertNotification({ param: { html: res.detail } });
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.overlay = false;
        });
      } else {
        this.setUrl("api/cfs-modificar-pdest");
        this.requestApi({
          method: "POST",
          data: {
            id: this.datosPuerto.ID,
            datosPuerto: this.datosPuerto
          },
        }).then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          this.dialogPuerto = false;
        }).catch((res) => {
          this.alertNotification({ param: { html: res.detail } });
          this.setLoadingTable(false);
        }).finally(() => {
          this.overlay = false;
        });
      }
    },

    eliminarPuertoCfs(puertoId) {
      Vue.swal({
        html: "Está seguro de eliminar el puerto ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.overlay = true;
          this.setUrl("api/cfs-borrar-pdest");
          this.requestApi({
            method: "POST",
            data: {
              id: puertoId,
            },
          }).then((res) => {
            //console.log(res);            
            this.cargarDatosCertificado(this.datosCfs.CFS_ID);
            this.alertNotification({ param: { html: res.data.msg } });
            this.overlay = false;
          }).catch(() => {
            this.overlay = false;
            this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          }).finally(() => {
            this.overlay = false;
          });
        }
      });
    },

    abrirDialogProductoCfs(item) {
      this.dialogProducto = true;
      this.overlay = true;

      if(item != null){
        this.datosProducto = {
          ID: item.ID,
          CODIGO_PRODUCTO: item.CODIGO_PRODUCTO,
          IDENT_EXPORTADOR: item.IDENT_EXPORTADOR,
          CANTIDAD: item.CANTIDAD,
          BULTOS: item.BULTOS
        };
      } else {  
        this.datosProducto = {
          ID: "",
          CODIGO_PRODUCTO: "",
          IDENT_EXPORTADOR: "",
          CANTIDAD: "",
          BULTOS: ""
        };
      }
      this.overlay = false;
      /*this.setUrl("api/cfs-datos-producto");
      this.requestApi({
        method: "GET",
        data: {
          id: null,
        },
      }).then((res) => {
        if (res.data.producto != null) {
          this.datosProducto = res.data.producto;
        } else {
          this.datosProducto = {};
        }
        this.dialogProducto = true;
      }).catch((res) => {
        this.overlay = false;
      }).finally(() => {
        this.overlay = false;
      });*/
    },
    abrirDialogCfsDeGuia() {
      this.dialogCfsDeGuia = true;
      this.numGuia = "";
    },
    crearCfsDeGuia() {
      
      if (this.numGuia == "") {
        this.alertNotification({
          param: {
            html: "Ingrese el número de guía",
            timer: 3000,
            icon: "error",
            title: "Error",
            type: "error",
          },
        });

        return false;
      }
      
      this.overlay = true;
      this.setUrl("api/cfs-verificar-certificado-guia");
      this.requestApi({
        method: "POST",
        data: {
          num_guia: this.numGuia,
          crearUnCfsPorExportador: this.crearUnCfsPorExportador,
        },
      })
        .then((res) => {
          
          if (res.data.existeCertificado == true) {

            Vue.swal({
              html: "Ya existe un certificado para esta guía. Desea volver a crearlo? Advertencia: Se perderán los datos actuales.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              ...this.paramAlertQuestion,
            }).then((result) => {
              if (result.isConfirmed) {
                /////
                this.overlay = true;
                
                this.setUrl("api/cfs-crear-certificado-guia");
                this.requestApi({
                  method: "POST",
                  data: {
                    num_guia: this.numGuia,
                    crearUnCfsPorExportador: this.crearUnCfsPorExportador,
                  },
                })
                  .then((res) => {                    
                    this.alertNotification({ param: { html: res.data.msg } });
                    this.dialogCfsDeGuia = false;
                    this.cargarLista();
                  })
                  .catch((res) => {                    
                    this.alertNotification({ param: { html: res.data.msg } });
                    this.setLoadingTable(false);
                  })
                  .finally(() => {
                    this.overlay = false;
                  });


                //////
              }
            });

          } else {
            this.alertNotification({ param: { html: res.data.msg } });
            this.dialogCfsDeGuia = false;
            this.cargarLista();
          }

        })
        .catch((res) => {
          this.alertNotification({
            param: {
              html: res.data.detail,
              timer: 3000,
              icon: "error",
              title: "Error",
              type: "error",
            },
          });
          //this.alertNotification({ param: { html: res.detail, color: "red" ,icon: "error", type: "error"}  });
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    guardarProductoCfs() {
      if (!this.$refs.formProducto.validate()) {
           return false;
      }
      this.overlay = true;

      if(this.datosProducto.ID == ""){
      this.setUrl("api/cfs-agregar-producto");
      this.requestApi({
        method: "POST",
        data: {
          cfs_id: this.datosCfs.CFS_ID,
          datosProducto: this.datosProducto,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          this.dialogPuerto = false;
        })
        .catch((res) => {
          this.alertNotification({ param: { html: res.detail } });
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.overlay = false;
        });
      } else {
        this.setUrl("api/cfs-modificar-producto");
        this.requestApi({
          method: "POST",
          data: {
            id: this.datosProducto.ID,
            datosProducto: this.datosProducto
          },
        }).then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarDatosCertificado(this.datosCfs.CFS_ID);
          this.dialogProducto = false;
        }).catch((res) => {
          this.alertNotification({ param: { html: res.detail } });
        })
        .finally(() => {
          this.overlay = false;
        });
      }
    },

    esOrnamental(tipoSolicitud) {
      return (tipoSolicitud || "").trim().toUpperCase() == "ORNAMENTALES";
    },

    nombreUsoPrevisto(codigo) {
      let uso = this.usosPrevistos.find((u) => u.COD_USO_PREVISTO == codigo);
      return uso ? uso.NOMBRE : codigo;
    },

    ajustarUsoPrevisto() {
      let ornamental = this.esOrnamental(this.datosCfs.TIPO_SOLICITUD);
      if (!ornamental && this.datosCfs.COD_USO_PREVISTO == "0004") {
        this.datosCfs.COD_USO_PREVISTO = "0002";
        this.alertNotification({
          param: { html: "El tipo de solicitud no es ORNAMENTALES, se cambió el uso previsto a <b>Consumo</b>. Verifique que sea correcto." },
        });
      } else if (ornamental && this.datosCfs.COD_USO_PREVISTO == "0002") {
        this.datosCfs.COD_USO_PREVISTO = "0004";
        this.alertNotification({
          param: { html: "El tipo de solicitud es ORNAMENTALES, se cambió el uso previsto a <b>Decoración</b>." },
        });
      }
    },

    confirmarUsoPrevisto(certificados) {
      let dudosos = certificados.filter(
        (c) => !this.esOrnamental(c.TIPO_SOLICITUD) && c.COD_USO_PREVISTO == "0004"
      );
      if (dudosos.length == 0) {
        return Promise.resolve(true);
      }
      let awbs = dudosos.map((c) => c.AWB || c.CFS_ID).join(", ");
      return Vue.swal({
        html: "Los certificados " + awbs + " no son ORNAMENTALES y tienen uso previsto <b>Decoración</b>. ¿Desea continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => result.isConfirmed);
    },

    async descargarXml() {
      if (!(await this.confirmarUsoPrevisto([this.datosCfs]))) {
        return;
      }
      this.setUrl("api/cfs-exportar-certificado-xml");

      this.requestApi({
        method: "POST",
        data: {
          cfs_id: this.datosCfs.CFS_ID,
        },
      })
        .then((res) => {
          let a = document.createElement("a");
          a.href = "data:application/xml;base64," + res.data.datos.datos;
          a.download = res.data.datos.nombreArchivo;
          a.click();
          this.alertNotification({ param: { html: res.data.msg } });
        })
        .then(() => { });
    },


    async descargarXmlMultiples() {
      if (!(await this.confirmarUsoPrevisto(this.selected))) {
        return;
      }
      this.setUrl("api/cfs-exportar-certificado-xml");

      let cfsIds = [];
      for (let i = 0; i < this.selected.length; i++) {
        cfsIds.push(this.selected[i].CFS_ID);
      }
      this.requestApi({
        method: "POST",
        data: {
          cfs_id: cfsIds,
        },
      })
        .then((res) => {
          let a = document.createElement("a");
          a.href = "data:application/xml;base64," + res.data.datos.datos;
          a.download = res.data.datos.nombreArchivo;
          a.click();
          this.selected = [];
          this.alertNotification({ param: { html: res.data.msg } });
        })
        .catch((res) => {
          this.alertNotification({ param: { html: res.data.detail , type: "error" , icon: "error" , timer: 3000 } });
        })
        .finally (() => {
          this.overlay = false;
        });
    },

    cambiarEstado(estado) {
      
      
      if(this.$refs.formEstadoCert.validate() == false){
        return false;
      }
      this.overlay = true;
      this.setUrl("api/cfs-cambiar-estado");
      this.requestApi({
        method: "POST",
        data: {
          cfs_id: this.datosCfs.CFS_ID,
          estado: estado,
          num_certificado: this.datosCfs.NUM_CERTIFICADO,
          user_name: this.user.user_login_id,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.dialogCfs = false;
          this.cargarLista();
        })
        .catch((res) => {
          this.alertNotification({ param: { html: res.data.detail , type: "error" , icon: "error" , timer: 3000 } });
        })
        .finally (() => {
          this.overlay = false;
        });
    },
    descargarAdjunto(url, nombre) {
      let a = document.createElement("a");
      a.href = url;
      a.download = nombre || "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Certificados Fitosanitarios de exportación");
    this.cargarLista();
  },
};
</script>